import { render, staticRenderFns } from "./TableComponentV3.vue?vue&type=template&id=5b0e4db0&scoped=true&"
import script from "./TableComponentV3.vue?vue&type=script&lang=js&"
export * from "./TableComponentV3.vue?vue&type=script&lang=js&"
import style0 from "./TableComponentV3.vue?vue&type=style&index=0&id=5b0e4db0&prod&lang=scss&scoped=true&"
import style1 from "./TableComponentV3.vue?vue&type=style&index=1&id=5b0e4db0&prod&lang=scss&"
import style2 from "./TableComponentV3.vue?vue&type=style&index=2&id=5b0e4db0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e4db0",
  null
  
)

export default component.exports